<template>
  <div>
    <div :class="styles.FORM.FORM_GROUP">
      <label>
        Disable by role setting?
        <input type="checkbox" v-model="control.disableByRoleSetting">
      </label>
    </div>
    <div :class="styles.FORM.FORM_GROUP">
      <label>Number of Rows</label>
      <input type="number" step="1" :class="styles.FORM.FORM_CONTROL" v-model.number="control.rows" />
      <small>`row` HTML Attribute Configuration</small>
    </div>

  </div>
</template>

<script>
import {BaseControlConfigSkeleton} from 'v-form-builder';

export default {
  name: 'TextAreaCustomControl',
  extends: BaseControlConfigSkeleton,
  data: () => ({
    inputModel: null,
  }),
};
</script>

<style scoped>

</style>
